<template>
  <div class="loading-container" v-if="visible">
    <div class="loading-wrapper">
      <img 
        :src="getImageUrl(isSuccess)" 
        :class="['loading-icon', { 'success': isSuccess }]" 
      />
      <div class="loading-text">{{ isSuccess ? '完成' : text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '加载中'
    },
    isSuccess: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getImageUrl(isSuccess) {
      try {
        return isSuccess 
          ? require('@/assets/collectionMappingSystem/success.svg')
          : require('@/assets/loading.svg')
      } catch (e) {
        console.error('加载图片失败:', e)
        return ''
      }
    }
  }
}
</script>

<style scoped>
.loading-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.loading-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.loading-icon {
  width: 60px;
  height: 60px;
  animation: rotate 1s linear infinite;
}

.loading-icon.success {
  animation: none;
}

.loading-text {
  color: #ffffff;
  font-size: 14px;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
